import React from 'react'
import {withStyles} from '@mui/styles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Slider from '@mui/material/Slider';
import Input from '@mui/material/Input';


 class RoofPitch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.roofpitch ? this.props.roofpitch : 45,
      width: this.props.width ? this.props.width : 100,
      origprops: this.props,
  
    }
  }


  handleSliderChange = (event, newValue) => {
    //console.log('handleSliderChange')
    //console.log(event);
    //console.log(newValue);
    //console.log('handleSliderChange End')

    if(newValue<=90) {
      this.setState({value: newValue})
      this.props.onChange({roofpitch: newValue})
    }
  };

  handleInputChange = (event) => {
    let value = 0;
    //console.log('handleInputChange')
    //console.log(typeof event.target.value)
    if(typeof event.target.value === 'string' ) 
      value = Number(event.target.value);
    else if(typeof event.target.value === 'number' ) 
      value = event.target.value;

    if( value <=90) {
      this.setState({value: value,origprops: this.props})
      this.props.onChange({roofpitch: value, value: value,  origprops: this.props})      
    }
    //if( this.state.origprops.roofpitch !== this.props.roofpitch) {
    //  value = this.props.roofpitch
    //}
  };

  handleBlur = () => {
    if (this.state.value < 0) {
      this.setState({value: 0});
    } else if (this.state.value > 90) {
      this.setState({value: 90});
    }
  };

  static getDerivedStateFromProps= (nextProps, prevState) => {
    // do things with nextProps.someProp and prevState.cachedSomeProp
    if(prevState.origprops.roofpitch !== nextProps.roofpitch)
      return {
        origprops: nextProps,
        value:  nextProps.roofpitch,
        // ... other derived state properties
      };
    return null

  }
  
  render() {
  const { classes } = this.props;

  return (
     
    <div  className={classes.root} >
      <div style={{height: this.state.width, width: this.state.width, marginLeft: 20}} >
       <svg xmlns="http://www.w3.org/2000/svg" height="100" width="100">
        <line x1="0" x2="0" y1="0" y2="90" style={{stroke: '#000000', strokewidth: 2}} />
        <line x1="0" x2="90" y1="90" y2="90" style={{stroke: '#000000', strokewidth: 2}} />
        <line x2="0" x1={90- this.state.value} y2={90-this.state.value} y1="90" style={{stroke: 'red', strokewidth: 2}} />
      </svg>
      </div>
      <Typography id="input-slider"  style={{marginLeft: 20, fontSize: 10}} >
        Roof Pitch (Deg)
      </Typography  >
      <Grid container spacing={2} alignItems="center" > 
        <Grid item>
        </Grid>
        <Grid item xs>
          <Slider
            value={typeof this.state.value === 'number' ? this.state.value : 0}
            onChange={this.handleSliderChange}
            aria-labelledby="input-sliderr" min={0} max={90} step={1} style={{marginLeft: 5}}
          />
        </Grid>
        <Grid item>
          <Input
            className={classes.input}
            value={this.state.value}
            margin="dense"
            onChange={this.handleInputChange}
            onBlur={this.handleBlur}
            inputProps={{
              step: 1,
              min: 0,
              max: 90,
              type: 'number',
              'aria-labelledby': 'input-sliderr',
            }}
          />
        </Grid>
      </Grid>
    </div>
  )
  }
}

const styles = theme => ({
  root: {
    width: 140,
    marginTop: 10,
  },
  input: {
    width: 40,
    fontSize: 12,
  },
  indent: {
    marginLeft: 20,

  }
});

export default withStyles(styles, { withTheme: true })(RoofPitch);
